module.exports = __webpack_public_path__ + "img/background.ec592264.svg";